<template>
  <div
    id="myTopnav"
    class="topnav"
  >
    <a
      href="/prepareMailers"
      class="brand-name"
    >
      <img
        class="logo"
        src="../assets/logo.png"
      > Email Builder
    </a>
    <div
      v-for="(menu, key) in menusList"
      v-show="isDashboard&&menu.access"
      :key="key"
      class="topDropdown"
    >
      <button class="dropbtn">
        {{ menu.name }}
        <i class="glyphicon glyphicon-menu-down" />
      </button>
      <div class="dropdown-menu">
        <a
          v-for="(submenu, subkey) in menu.submenus"
          v-show="submenu.access"
          :key="subkey"
          :href="`/${submenu.menu_url}`"
        >{{ submenu.menu_name }}</a>
      </div>
    </div>
    <div
      v-show="isDashboard"
      class="topDropdown pull-right"
    >
      <button class="dropbtn">
        {{ fullName }}
        <i class="glyphicon glyphicon-menu-down" />
      </button>
      <div class="dropdown-menu">
        <a
          href
          class="logoutLink"
          @click="logout()"
        >Logout</a>
      </div>
    </div>
  </div>
</template>

<script>
const access = {
  employee: ['CreateMailer', 'sliceToMailers', 'prepareMailers'],
  admin: [
    'prepareMailers',
    'CreateMailer',
    'sliceToMailers',
    'fasciaGroups',
    'createfasciaGroup',
    'fasciasList',
    'createfascia',
    'categoryList',
    'createcategory',
    'custommailer',
    'createcustommailer',
    'fasciawiseTemplates',
    'createfasciawiseTemplate',
  ],
};

export default {
  name: 'Headers',
  data() {
    return {
      menusList: [],
      userId: '',
      isDashboard: false,
      fullName: '',
      userRoleId: '',
    };
  },
  mounted() {
    if (this.$route.path === '/') {
      this.isDashboard = false;
    } else {
      const getroleId = fetch('/api/getUserData', {
        credentials: 'same-origin',
      });
      getroleId
        .then((response) => {
          if (!response.ok) {
            this.$router.push({ name: 'login' });
          } else {
            return response.json();
          }
          return false;
        })
        .then((response) => {
          if (response.data) {
            this.userRoleId = response.data.role_id;
            this.userId = response.data.id;
            this.fullName = response.data.full_name;
            this.$eventHub.$emit('userData', response.data);
            this.checkAccess();
            const getRolewiseAccess = fetch('/api/rolewiseMenuAccess/', {
              credentials: 'same-origin',
            });
            getRolewiseAccess
              .then(data => data.json())
              .then((data) => {
                this.menusList = JSON.parse(data.menu_access);
              });
          }
        });
    }
    this.isDashboard = true;
  },
  methods: {
    logout() {
      fetch('/api/logout', { credentials: 'same-origin' });
      this.$router.push({ name: 'login' });
    },
    checkAccess() {
      if (
        this.userRoleId === 1
        && access.employee.indexOf(this.$route.name) === -1
      ) {
        this.$router.push({ name: 'invalidAccess' });
      }
      if (
        this.userRoleId === 2
        && access.admin.indexOf(this.$route.name) === -1
      ) {
        this.$router.push({ name: 'invalidAccess' });
      }
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.logo {
  vertical-align: middle;
  margin-right: 10px;
  width: auto;
}

.topnav {
  overflow: hidden;
  background-color: #639;
}

.menu-icon {
  width: 20px;
  padding-right: 20px;
  margin: -6px;
  height: auto;
}

.topnav a {
  float: left;
  display: block;
  color: #f2f2f2;
  text-align: center;
  padding: 13px 18px;
  text-decoration: none;
  font-size: 17px;
}

.active {
  background-color: #4caf50;
  color: white;
  height: 27px;
}

.topnav .icon {
  display: none;
}

@media screen and (max-width: 600px) {
  .topnav a:not(:first-child) {
    display: none;
  }

  .topnav a.icon {
    float: right;
    display: block;
  }
}

@media screen and (max-width: 600px) {
  .topnav.responsive {
    position: relative;
  }

  .topnav.responsive .icon {
    position: absolute;
    right: 0;
    top: 0;
  }

  .topnav.responsive a {
    float: none;
    display: block;
    text-align: left;
  }
}

.topDropdown {
  float: left;
  overflow: hidden;
}

.pull-right {
  float: right;
}

.topDropdown .dropbtn {
  font-size: 17px;
  border: none;
  outline: none;
  color: white;
  padding: 18px 16px;
  background-color: inherit;
  font-family: inherit;
  margin: 0;
}

.dropdown-menu {
  display: none;
  position: absolute;
  background-color: white;
  min-width: 130px;
  font-size: 20px;
  box-shadow: 0 8px 16px 0 rgba(0, 0, 0, 0.2);
  z-index: 1;
  padding: 12px 16px;
}

.dropdown-menu a {
  float: none;
  color: black;
  padding: 12px 16px;
  text-decoration: none;
  display: block;
  font-size: 16px;
  text-align: left;
}

.dropdown-menu a:hover {
  background-color: black;
  color: white;
}

.topDropdown:hover .dropdown-menu {
  display: block;
}

.topDropdown:hover .glyphicon::before {
  content: "\e260";
}
</style>
